import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=4c83350c&"
import script from "./registerSuccess.vue?vue&type=script&lang=js&"
export * from "./registerSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports